import { createRoot } from 'react-dom/client';

import { enableMocking } from '@oaknorth/mocks/enableMocking';

import { App } from './app';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- we know root is always there
const root = createRoot(container!);

enableMocking().then(() => root.render(App()));
